import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TEST_IDS } from '../../constants';
import styles from './styles.module.css';
export function OverlayElement({ onClose, content, blur = false }) {
    const handleClick = e => {
        e.stopPropagation();
        onClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.modalOverlay, "data-blur": blur || undefined, onClick: handleClick, "data-test-id": TEST_IDS.overlay }), content] }));
}
